import { render, staticRenderFns } from "./ReservationNotes.vue?vue&type=template&id=59c96a46&scoped=true"
import script from "./ReservationNotes.vue?vue&type=script&lang=js"
export * from "./ReservationNotes.vue?vue&type=script&lang=js"
import style0 from "./ReservationNotes.vue?vue&type=style&index=0&id=59c96a46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c96a46",
  null
  
)

export default component.exports